import type {
  InspectionSession,
  InspectionUser,
} from '../../services/roomInspectorApi';

export interface ParticipantIdentity {
  kind: 'user' | 'agent';
  id: string;
  name: string;
  avatarUrl?: string;
  ownerUserId?: string;
  ownerName?: string;
  ownerAvatarUrl?: string;
}

const agentProviders = new Map([
  ['codex', 'Codex'],
  ['claude-code', 'Claude Code'],
  ['tutti', 'Tutti'],
  ['opencode', 'OpenCode'],
]);

export function userParticipant(
  actorUserId: string,
  users: Map<string, InspectionUser>,
): ParticipantIdentity {
  const user = users.get(actorUserId);
  return {
    kind: 'user',
    id: actorUserId,
    name: user?.displayName?.trim() || actorUserId || '未知用户',
    avatarUrl: user?.avatarUrl || undefined,
  };
}

export function agentParticipant(
  session: InspectionSession,
  users: Map<string, InspectionUser>,
): ParticipantIdentity {
  const target = session.agentTargetPresentation;
  const provider = target?.provider?.trim() || session.provider?.trim() || '';
  const iconKey = target?.iconKey?.trim() || provider;
  const ownerUserId = target?.ownerUserId;
  const owner = ownerUserId ? users.get(ownerUserId) : undefined;
  return {
    kind: 'agent',
    id: session.agentTargetId || '',
    name:
      target?.displayName?.trim() ||
      agentProviders.get(provider) ||
      provider ||
      'Agent',
    avatarUrl: agentProviders.has(iconKey)
      ? `/agent-avatar/${iconKey}.svg`
      : undefined,
    ownerUserId,
    ownerName:
      target?.ownerDisplayName?.trim() ||
      owner?.displayName?.trim() ||
      ownerUserId,
    ownerAvatarUrl: target?.ownerAvatarUrl || owner?.avatarUrl || undefined,
  };
}
